import { atomWithReset } from 'jotai/utils';

export const atomHasInbox = atomWithReset<boolean>(false);
atomHasInbox.debugLabel = 'atomHasInbox';
